module.exports = __webpack_public_path__ + "static/media/DC-logo.9ef9b4c8.png";